import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { toast } from '@CommonComponents/toast'
import PropTypes from 'prop-types'
import { client } from '@Utils'
import { canvasConnect as endpoints } from '@URLS'
import { useStateValue } from '@State'
import { AssessmentSetup } from './AssessmentSetup'
import { SelectedAssessmentsContainer } from './SelectedAssessmentsContainer'
import { ConfigBase } from '../base_comps/ConfigBase.js'

const ConfigAsmtsPageComp = () => {
  const [currentState, dispatch] = useStateValue()
  let params = window.location.pathname.split('/')
  let coursenum = params[3]
  let contextId = window.location.pathname.split('/')[4]
  useEffect(() => {
    async function getAsmtData(contextId) {
      try {
        let resp = await client.get(endpoints.getInstructorData({ contextId }))
        await dispatch({
          type: 'updateInstructorData',
          payload: { connectedCourses: resp.data.connectedCourses },
        })
      } catch (err) {
        console.log(err)
        toast.error(err.response.data.error)
      }
    }
    getAsmtData(contextId)
  }, [])

  const checkFunc = (allActs, selActs) => {
    if (allActs.length == 0) {
      return false
    }
    return allActs.every(act =>
      selActs.map(selAct => selAct.actPk).includes(act.actPk)
    )
  }

  const selFunc = (allActs, selActs, dispatch) => {
    let allSelected = allActs.every(act =>
      selActs.map(selAct => selAct.actPk).includes(act.actPk)
    )
    if (allSelected) {
      dispatch({
        type: 'assessmentGroupSelection',
        selectedAssessments: [],
      })
    } else {
      dispatch({
        type: 'assessmentGroupSelection',
        selectedAssessments: currentState.allActs,
      })
    }
  }

  const expandFunc = (allGroupPks, expAsmts) => {
    let allExpanded = allGroupPks.every(groupPk =>
      expAsmts.map(expAsmt => expAsmt).includes(groupPk)
    )
    let payload
    let actionType = 'expandAssessments'
    if (allExpanded) {
      return
    } else {
      payload = allGroupPks
    }

    dispatch({
      type: actionType,
      payload: payload,
    })
  }

  return (
    <ConfigBase
      courseTitle={
        currentState.connectedCourses.length > 0 &&
        currentState.connectedCourses.filter(
          course => coursenum === course.coursenum
        )[0].courseTitle
      }
      pageTitle="Assessment"
      leftSide={AssessmentSetup}
      rightSide={SelectedAssessmentsContainer}
      allItems={currentState.allActs}
      itemsPosted={currentState.linksPosted}
      itemsPosting={currentState.linksPosting}
      checkFunc={checkFunc}
      funcParams={[currentState.allActs, currentState.selectedAssessments]}
      dispatch={dispatch}
      selFunc={selFunc}
      expandFunc={expandFunc}
      expandFuncParams={[
        Object.keys(currentState.assessmentGroups),
        currentState.expandedAsmts,
      ]}
      expandFuncType={'expandAssessments'}
    />
  )
}

ConfigAsmtsPageComp.propTypes = {
  history: PropTypes.object,
}

export const ConfigAsmtsPage = withRouter(ConfigAsmtsPageComp)
